/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_shipment = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_shipment" | "PdpRespShippingReturns_shipment">;
    readonly " $refType": "PdpRespContainer_shipment";
};
export type PdpRespContainer_shipment$data = PdpRespContainer_shipment;
export type PdpRespContainer_shipment$key = {
    readonly " $data"?: PdpRespContainer_shipment$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipment">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_shipment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_shipment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_shipment"
    }
  ],
  "type": "Shipment",
  "abstractKey": null
};
(node as any).hash = '420fd2aa2770bf47e7c888011c42b0e9';
export default node;
